import { getFromLocalStorage, removeFromLocalStorage, showErrorToast } from "src/lib/utils";

export const onReqFulfilled = (config) => {
	const access_token = getFromLocalStorage("access_token");

	if (access_token) {
		config.headers["Authorization"] = `Bearer ${access_token}`;
	}

	return config;
};

export const onReqRejected = (error) => {
	if (process.env.NODE_ENV === "development") {
		console.error(error);
	}

	return Promise.reject(error);
};

export const onResFulfilled = (response) => response.data;

export const onResRejected = (error) => {
	if (process.env.NODE_ENV === "development") {
		console.error(error);
	}

	if (["ERR_NETWORK", "ECONNABORTED", "ETIMEDOUT"].includes(error.code)) {
		showErrorToast("Network error", {
			description: "Please check your connection and try again",
			closeButton: true,
		});

		return Promise.reject(error.response?.data?.message || error.response);
	}

	if (error?.response?.status === 401) {
		removeFromLocalStorage("access_token", "user", "selectedBusiness", "selectedChild");

		window.location.reload();

		showErrorToast("Session expired", {
			description: "Please login again",
			closeButton: true,
		});

		return Promise.reject(error.response?.data?.message || error.response);
	}

	if (error?.response?.status === 403) {
		showErrorToast(error.response?.data?.message || "Permission denied", {
			closeButton: true,
		});
		return Promise.reject(error.response?.data?.message || error.response);
	}

	showErrorToast(error.response?.data?.message || "Something went wrong", {
		closeButton: true,
	});

	return Promise.reject(error.response?.data?.message || error.response);
};
